export default "/assets/images/badge-01.c3d26e4174b9bcf6.webp";